import UrlPattern from '@/support/UrlPattern';

export const ValidationRules = (): Rules => ({
  required: (value: string): boolean | string => !! value || 'Dit veld is verplicht',
  name: (value: string): boolean | string => {
    const pattern = /^[a-zA-Z0-9\-]+$/;
    return !! pattern.test(value) || 'Ongeldige naam';
  },
  url: (value: string): boolean | string => !! UrlPattern.test(value) || 'Ongeldige url',
  email: (value: string): boolean | string => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !! pattern.test(value) || 'Ongeldige email';
  },
  number: (value: string): boolean | string => {
    const pattern = /^[0-9]+$/;
    return !! pattern.test(value) || 'Ongeldig telefoonnummer';
  },
  valuta: (value: string): boolean | string => {
    const pattern = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/;
    const correctDecimalLength: boolean = value.split('.').length > 0 ? value.split('.')[1].length <= 2 : true;
    return !! (pattern.test(value) && correctDecimalLength) || 'Ongeldige valuta';
  },
  time: (value: string): boolean | string => {
    const pattern = /^(0[0-9]|1[0-9]|2[0-3]|[0-9])[0-5][0-9]$/;
    return !! pattern.test(value) || 'Ongeldige tijd';
  },
  date: (value: string): boolean | string => {
    const pattern = /((0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-[12]\d{3})/;
    return !! pattern.test(value) || 'Ongeldige datum';
  },
  alphanumeric: (value: string): boolean | string => {
    if (! /^[a-z0-9]+$/i.test(value)) {
      return 'Geen speciale tekens of spaties toegestaan';
    }
    return true;
  },
  alphanumericWithSpace: (value: string): boolean | string => {
    if (! /^[a-z\d\-_\s]+$/i.test(value)) {
      return 'Geen speciale tekens toegestaan.';
    }
    return true;
  },
  lowercase: (value: string): boolean | string => {
    const pattern = /[a-z]+/;
    return !! pattern.test(value) || 'Alleen hoofdletters toegestaan';
  },
  uppercase: (value: string): boolean | string => {
    const pattern = /[A-Z]+/;
    return !! pattern.test(value) || 'Geen hoofdletters toegestaan';
  },
  length: (value: string): boolean | string => {
    const pattern = /.{8,}/;
    return !! pattern.test(value) || 'minimaal 8 tekens verplicht';
  },
  lengthExactly3: (value: string): boolean | string => !! (value && value.length === 3) || 'Exactly 3 characters',
  lengthMinimum2: (value: string): boolean | string => !! (value && value.length >= 2) || 'At least 2 characters',
  lengthMinimum6: (value: string): boolean | string => !! (value && value.length >= 6) || 'Minimaal 6 tekens',
  lengthMinimum8: (value: string): boolean | string => !! (value && value.length >= 8) || 'Minimaal 8 tekens',
  lengthMinimum10: (value: string): boolean | string => !! (value && value.length >= 10) || 'Minimaal 10 tekens',
  numberPassword: (value: string): boolean | string => {
    const pattern = /[0-9]+/;
    return !! pattern.test(value) || 'Eén nummer vereist';
  },
  special: (value: string): boolean | string => {
    const pattern = /\W|_/g;
    return !! pattern.test(value) || 'Eén speciaal teken vereist';
  },
  dutchPhone: (value: string): boolean | string => {
    const pattern = /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/g;
    return !! pattern.test(value) || 'Ongeldig telefoonnummer';
  },
  dutchPostcode: (value: string): boolean | string => {
    const pattern = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
    return !! pattern.test(value) || 'Ongeldige postcode';
  },
});

export type Rule = (value: string) => boolean | string;

export interface Rules {
  [key: string]: Rule;
}
